/* Version: 3.5.137 */
'use client';
var BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  TERTIARY_BACK: 'tertiary_back',
  TERTIARY_NOICON: 'tertiary_noicon',
  SIGN_IN: 'sign_in'
};

export { BUTTON_VARIANT };
